export default function Logout() {
  $.ajax({
    type: "POST",
    url: "/api/account/signout",
    async: false,
    contentType: "application/json",
    success: function () {
      location.reload();
    }
  });
}